import { useCallback } from 'react';
import { QuestionnaireTemplateStore } from '../../store/questionnaireTemplateModel';
import { useBlockNavigation } from './useBlockNavigation';

export const useUnsavedChanges = ({ isDisabled }: { isDisabled: boolean }): { isDirty: boolean } => {
  const isDirty = QuestionnaireTemplateStore.useStoreState((s) => s.isDirty);
  const reset = QuestionnaireTemplateStore.useStoreActions((a) => a.reset);

  const handleConfirmLeave = useCallback(() => reset(), [reset]);

  useBlockNavigation({
    isDisabled,
    shouldBlock: isDirty,
    onConfirmLeave: handleConfirmLeave,
  });
  return { isDirty };
};
